import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { PolicyHolderPropTypes } from '../../../propTypes/petDetails';
import { NameDetails } from './nameDetails/nameDetails';
import { AddressDetails } from './addressDetails/addressDetails';
import { ContactDetails } from './contactDetails/contactDetails';
import { PasswordDetails } from './passwordDetails/passwordDetails';
import { BrandContext } from '../../../contextProviders/brandContext';
import { AUTHENTICATION_TYPES } from '../../../constants/constants';
import './policyHolderDetails.scss';

export const PolicyHolderDetails = ({ policyHolder, numPolicyHolders = 1 }) => {
  const HandleEditNameFAQ = () => {};
  const { authenticationType } =
    useContext(BrandContext).activeBrandContext.cspConfiguration.auth0Config[process.env.REACT_APP_ENV];
  const isSsoAuthentication = authenticationType === AUTHENTICATION_TYPES.SSO;

  return (
    <div className="policyHolderDetails">
      <NameDetails
        policyHolder={policyHolder}
        numPolicyHolders={numPolicyHolders}
      />

      <AddressDetails
        policyHolder={policyHolder}
        numPolicyHolders={numPolicyHolders}
      />

      <ContactDetails
        policyHolder={policyHolder}
        numPolicyHolders={numPolicyHolders}
      />

      {!isSsoAuthentication && (
        <PasswordDetails
          policyHolder={policyHolder}
          numPolicyHolders={numPolicyHolders}
        />
      )}
    </div>
  );
};

PolicyHolderDetails.propTypes = {
  policyHolder: PolicyHolderPropTypes,
  numPolicyHolders: PropTypes.number
};
